import { createContext, useContext } from "react";
import type { ChatMessage } from "../types/assistant";

type ChatMessagesContextValue = {
  messages: ChatMessage[];
  userEmail: string;
};

const ChatMessagesContext = createContext<ChatMessagesContextValue>({
  messages: [],
  userEmail: "",
});

export function ChatMessagesProvider({
  messages,
  userEmail = "",
  children,
}: {
  messages: ChatMessage[];
  userEmail?: string;
  children: React.ReactNode;
}) {
  return (
    <ChatMessagesContext.Provider value={{ messages, userEmail }}>
      {children}
    </ChatMessagesContext.Provider>
  );
}

export function useChatMessages() {
  return useContext(ChatMessagesContext).messages;
}

export function useChatUserEmail() {
  return useContext(ChatMessagesContext).userEmail;
}

export function useChatMessageById(id: string) {
  const messages = useChatMessages();
  return messages.find((m) => m.id === id);
}
